import React, { Component } from 'react';
import { Form, FormGroup, Label, Input, FormFeedback, CardBody, Card } from 'reactstrap'
import Fetch from '../../Auxiliares/fetch'
import validaciones from '../../Auxiliares/validaciones'
import { toast } from 'react-toastify'

export default class cambiar_usuario extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: sessionStorage.getItem('_id'),
            usuario: sessionStorage.getItem('usuario'),
            errors: {}
        }
        this.actualizar = this.actualizar.bind(this)
    }

    setValue(field, ev) {
        this.setState({ [field]: ev.target.value }, () => {
            let value;
            switch ([field].toString()) {
                case 'usuario':
                    if (validaciones.validar_usuario(this.state.usuario)) {
                        value = validaciones.validar_usuario(this.state.usuario)
                        this.setState(prevState => ({ errors: { ...prevState.errors, usuario: value } }));
                    } else {
                        this.setState({ errors: (delete Array.from(this.state.errors).usuario) });
                    }
                    break;

                default:
                    break;
            }
        })
    }

    actualizar(e) {
        e.preventDefault();

        const { id, usuario } = this.state
        Fetch('/api/updateUsuarioCuenta', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id, usuario })
        })
            .then(response => {
                sessionStorage.setItem('usuario', usuario)
                toast.success('Actualizacion Exitosa!')
            })
            .catch(err => {
                switch (err.status) {

                    case 600:
                        console.log('Error inesperado')
                        break;

                    case 605:
                        console.log('Listado de elementos vacia')
                        break;

                    default:
                        break;
                }
            })
    }

    render() {
        return (
            <div class="container h-100">
                <div class="row h-100 justify-content-center align-items-center">
                    <Card className="p-3 border-0">
                    <Form onSubmit={this.actualizar}>
                        <FormGroup>
                            <Label className="font-weight-bold float-left">usuario:</Label>
                            <Input className="w-100" type="text" name="usuario" defaultValue={this.state.usuario} onChange={this.setValue.bind(this, "usuario")}/>
                            <FormFeedback>{this.state.errors.usuario}</FormFeedback>
                        </FormGroup>

                        <CardBody>
                            <Input type="submit" className="btn btn-info" value="Guardar"/>
                        </CardBody>
                    </Form>
                    </Card>
                </div>
            </div> 
        )
    }
}